<div>
  <h6 class="odx-title-6" i18n="@@global.notes">Notizen</h6>

  <app-floorplan-menu-item-buttons>
    <app-add-button
      (add)="addFloorplanText()"
      [odxTooltip]="tooltipTextAddNote"
      [odxTooltipOptions]="{ position: 'bottom' }"
      (dragStart)="dragFloorplanText()"
    ></app-add-button>
    <app-toggle-visibility-button
      [visible]="floorplanState.floorplanTextsVisible"
      (toggleEvent)="floorplanState.floorplanTextsVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.floorplanTextsItemTextVisible"
      (toggleEvent)="updateNotesItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplanState.floorplanTextsLocked"
      (toggleEvent)="floorplanState.floorplanTextsLocked = $event"
    >
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
